import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getLabel from './../../../utils/labels'
import styles from './helpMenu.module.scss';

class HelpMenu extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { introductionData } = this.props
        return (
            <div className={styles.container}>
                <div className={styles.item} onClick={() => this.props.onOptionClick(1)}>
                    {introductionData.introPage.step1Header ? introductionData.introPage.step1Header : 'About Company'}
                </div>
                <div className={styles.item} onClick={() => this.props.onOptionClick(2)}>
                    {introductionData.introPage.step2Header ? introductionData.introPage.step2Header : 'About Character'}
                </div>
                <div className={styles.item} onClick={() => this.props.onOptionClick(3)}>
                    {introductionData.introPage.step3Header ? introductionData.introPage.step3Header : "Objectives"}
                </div>
                <div className={styles.item} onClick={() => this.props.onOptionClick(4)}>
                    {getLabel('label_org_chart_text')}
                </div>
            </div>
        )
    }
}

HelpMenu.propTypes = {
    timeLeft: PropTypes.number
};

HelpMenu.defaultProps = {
    timeLeft: -1
};

export default HelpMenu;


// WEBPACK FOOTER //
// /src/components/header/helpMenu/HelpMenu.js